import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingAgentTasksScreen } from './pricing-agent-tasks-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';

export const PricingAgentTasksScreenWrapper: React.FC = () => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();
  const {
    loading: accessLoading,
    error: accessError,
    hasPricingAgentAccess,
  } = useBusinessOrganizationPricingConfig();

  useEffect(() => {
    if (!accessLoading && !accessError && !hasPricingAgentAccess) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [accessError, accessLoading, hasPricingAgentAccess, navigation]);

  return accessLoading ? <LogoLoadingIndicator /> : <PricingAgentTasksScreen />;
};
